import { createSlice } from "@reduxjs/toolkit";
import { initialAoiState } from "../config/config.aoi";

const aoiSlice = createSlice({
  name: "aoi",
  initialState: initialAoiState,
  reducers: {
    setOverlay(state, action) {
      state.overlay = action.payload.id;
    },
    setSelection(state, action) {
      const { catId, selectedIds } = action.payload;
      state.selection.category = catId;
      state.selection.selectedIds = selectedIds;
      state.overlay = null;
    },
    addSelection(state, action) {
      const { catId, id } = action.payload;
      // if(state.selection.category === catId || !state.selection.category) {
        state.selection.category = catId;
        if(state.selection.selectedIds.findIndex(o => o.id === id) === -1){
          state.selection.selectedIds.push(id);
        }
        state.overlay = null;
      // } else{
      //   console.warn("Could not update AOI selection - AOI category mismatch")
      // }
    }
  },
});
export { aoiSlice };
